import React, { useState } from "react";
import { Card, Form, Input, Button, notification, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import "./index.scss";

import { apiLogIn } from "api/api";

import { useDispatch, useSelector } from "react-redux";
import { setToken } from "store/slice/index";

const LogIn = () => {
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  // # notification
  const [api, contextHolder] = notification.useNotification();

  const onFinish = (values) => {
    setIsLoading(true);
    login(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const login = async (values) => {
    try {
      const res = await apiLogIn(values);
      const { token } = res.data.content;
      dispatch(setToken(token));
      sessionStorage.t = token;
      navigate("/events");
    } catch (err) {
      console.log("error", err.response);
      api.error({
        message: `登入失敗`,
        description: <p>請確認帳號密碼是否正確</p>,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="sm:px-2 sm:pt-48 px-56 1920:pt-80 pt-60 h-[100vh] area">
      {contextHolder}
      <div>
        <Card
          title={
            <h3>
              <img src="/Logo.png" className="w-4/5" />
              <span className="text-right">後台登入</span>
            </h3>
          }
          classNames={{ header: "bg-Deep-Blue text-white sm:block hidden" }}
          className=" 1920:w-[40%] 1366:w-[60%]  mx-auto sm:w-full shadow-xl z-10 [&_.ant-card-body]:p-0 border-none"
        >
          <Flex gap="large">
            <div className="sm:hidden rounded-tl-lg rounded-bl-lg w-full bg-Deep-Blue p-6 items-center flex">
              <img src="/Logo.png" />
            </div>

            <Form
              name="login"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical"
              className="w-full p-6"
            >
              <Form.Item
                label="Account"
                name="account"
                rules={[
                  {
                    required: true,
                    message: "Please input your username!",
                  },
                ]}
              >
                <Input autoComplete="off" />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item>
                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  className="w-full bg-Deep-Blue"
                  loading={isLoading}
                >
                  登入
                </Button>
              </Form.Item>
            </Form>
          </Flex>
        </Card>
      </div>
      {/* <div class="area">
        <ul class="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div> */}
    </div>
  );
};

export default LogIn;
